module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "-19px",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticStyle: {
      "padding": "0 12px"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "display": "flex",
      "margin-top": "10px",
      "height": "55px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "活动栏目："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动栏目名称",
      "maxlength": "10"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "change-on-select": ""
    },
    on: {
      "change": _vm.handleChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-left": "30px"
    },
    attrs: {
      "label": "商品品类："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getbrandarr
    },
    model: {
      value: (_vm.filters.brandTypeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeId", $$v)
      },
      expression: "filters.brandTypeId"
    }
  }, _vm._l((_vm.brandTypearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "display": "flex",
      "margin-top": "10px",
      "height": "55px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "33.3%"
    },
    attrs: {
      "label": "商品品牌："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.brandId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandId", $$v)
      },
      expression: "filters.brandId"
    }
  }, _vm._l((_vm.brandarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "33.3%"
    },
    attrs: {
      "label": "状　　态："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.stateId),
      callback: function($$v) {
        _vm.stateId = $$v
      },
      expression: "stateId"
    }
  }, _vm._l((_vm.statearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "33.3%",
      "margin-left": "30px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.findinfo()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("快捷操作")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-left": "8px",
      "margin-top": "15px",
      "border-bottom": "1px solid #eee",
      "padding-bottom": "15px"
    }
  }, [_c('p', {
    staticClass: "add_new_btn butstyle",
    staticStyle: {
      "margin": "0px",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.showAdd()
      }
    }
  }, [_vm._v("新增栏目")]), _vm._v(" "), _c('p', {
    staticClass: "add_new_btn butstyle",
    staticStyle: {
      "margin": "0px",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.opencolmn(1)
      }
    }
  }, [_vm._v("开 启")]), _vm._v(" "), _c('p', {
    staticClass: "add_new_btn butstyle",
    staticStyle: {
      "margin": "0px",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.opencolmn(0)
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('p', {
    staticClass: "add_new_btn butstyle",
    staticStyle: {
      "margin": "0px",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.deletegoods()
      }
    }
  }, [_vm._v("删 除")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("栏目管理")])]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "tabler_inner_container"
  }, [_c('el-table', {
    staticClass: "ban_tab",
    staticStyle: {
      "height": "auto",
      "margin-left": "-14px",
      "margin-top": "10px"
    },
    attrs: {
      "header-cell-style": {
        background: '#bbbbbb'
      },
      "data": _vm.users,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "栏目名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Name
          }
        }, [_vm._v(_vm._s(scope.row.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CityName",
      "label": "所属城市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.CityName
          }
        }, [_vm._v(_vm._s(scope.row.CityName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SortNumber",
      "label": "顺序",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.SortNumber
          }
        }, [_vm._v(_vm._s(scope.row.SortNumber))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OpenName",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.OpenName
          }
        }, [_vm._v(_vm._s(scope.row.OpenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodsCounts",
      "label": "商品数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.GoodsCounts
          }
        }, [_vm._v(_vm._s(scope.row.GoodsCounts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "width": "270px",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.offer(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v("\n                  编辑\n                ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteone(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v("\n                  删除\n                ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.upordown(0, scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v("\n                  向上\n                ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.upordown(1, scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v("\n                  向下\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar_footer",
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-right": "14px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "goodslist1",
    staticStyle: {
      "margin": "0",
      "margin-left": "-22px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "31px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "goods_red"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-081ed9e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/Activitycolumn.vue
// module id = 1630
// module chunks = 3